module.exports = __webpack_public_path__ + "img/arrow-cta.ef7f0b6.svg";